import { render, staticRenderFns } from "./PitchFeeChanged.vue?vue&type=template&id=16670734"
import script from "./PitchFeeChanged.vue?vue&type=script&lang=js"
export * from "./PitchFeeChanged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports